import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateNumber',
  standalone: true
})
export class TruncateNumberPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe, private currencyPipe: CurrencyPipe) { 

  }

  transform(value: number | string, digits: number = 0, type: string = 'text'): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    // Handling null or undefined or NaN values
    if (!value && value !== 0 || isNaN(value)) {
      return '0';
    }

    let newValue: number;
    let suffix: string = '';

    // Utilizing fixed-point notation for more accurate and controlled formatting
    if (value >= 1_000_000_000) {
      newValue = value / 1_000_000_000;
      suffix = 'B';
    } else if (value >= 1_000_000) {
      newValue = value / 1_000_000;
      suffix = 'M';
    } else {
      newValue = value;
    }

    // Using the DecimalPipe or CurrencyPipe based on the type
    if (type === 'currency') {
      return `${this.currencyPipe.transform(newValue, 'USD', 'symbol', '1.0-0')}${suffix}`;
    } else if (type === 'number') {
      return `${this.decimalPipe.transform(newValue, `1.0-${digits}`)}${suffix}`;
    }

    // Using toFixed to provide a fixed number of decimal places
    // Converts the number to string while limiting the decimal places to `digits`
    return `${newValue.toFixed(digits)}${suffix}`;
  }
}